import moment from "moment";

const formatString = "h:mm A";

/**
 * Generates a list of time slots for the whole day, including
 * the end of the day, based on a given range,
 * where each time slot is parsed using moment.js.
 *
 * @param {number} range - The interval for each slot.
 * @returns {Array<string>} A list of all the available slots for the day.
 *
 * @example generateTimeSlots(30) // Output:
 *  [12:00 AM, 12:30 AM, 1:00 AM, ..., 11:30 PM, 11:59 PM]
 */
export const generateTimeSlots = (range: number): Array<string> => {
    const totalSlots = Math.round((60 * 24) / range);
    const time = moment().startOf("day");
    const timeEnd = moment().endOf("day");
    const timeslots = [time.format(formatString)];

    for (let slot = 0; slot < totalSlots; slot++) {
        time.add(range, "minute");
        if (time.isBefore(timeEnd)) {
            timeslots.push(time.format(formatString));
        }
    }

    // Add the end of the day time.
    // This allows the user to select a value close
    // to the end of the time frame.  Such as 11:59 pm
    // instead of 11:45 pm.
    const finalTimeSlot = timeEnd.format(formatString);
    if (!timeslots.includes(finalTimeSlot)) {
        timeslots.push(timeEnd.format(formatString));
    }

    return timeslots;
};
